export enum OmEmeaCountryOptions {
    // Existing
    AT = 'Austria',

    // Wave 1
    NL = 'Netherlands',
    TR = 'Turkey',

    // Wave 2
    NO = 'Norway',
    SE = 'Sweden',
    DK = 'Denmark',
    FI = 'Finland',
    EE = 'Estonia',
    LV = 'Latvia',
    LT = 'Lithuania',
    GB = 'Great Britain',
    BE = 'Belgium',
    LU = 'Luxembourg',

    // Wave 3
    CZ = 'Czech Republic',
    PL = 'Poland',

    // Wave 4
    FR = 'France',
    PT = 'Portugal',
    ES = 'Spain',
    IT = 'Italy',
    CH = 'Switzerland',
    DE = 'Germany'

    // Wave 5
    //AE = 'United Arab Emirates',
    //SA = 'Saudi Arabia',
    //EG = 'Egypt',
    //ZA = 'South Africa'
}
